import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AccessTokenCreateModal from "./AccessTokenCreateModal";
import AccessTokenRotateModal from "./AccessTokenRotateModal";

function formatRelative(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString();
}

export default function AccessTokenList({
  tokens,
  loading,
  onCreate,
  onRevoke,
  onRotate,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [rotateTarget, setRotateTarget] = useState(null);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">Tokens de acceso (M2M)</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setModalOpen(true)}>
          Crear token
        </Button>
      </Stack>

      <Alert severity="info" sx={{ mb: 2 }}>
        Solo administradores pueden gestionar tokens. Integraciones legacy usan{" "}
        <code>POST /auth</code> con <code>Authorization: Basic</code> y luego Bearer contra la API.
      </Alert>

      <Paper variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Label</TableCell>
              <TableCell>Client ID</TableCell>
              <TableCell>Scopes</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Último uso</TableCell>
              <TableCell>Creado</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={7}>Cargando…</TableCell>
              </TableRow>
            )}
            {!loading && tokens.length === 0 && (
              <TableRow>
                <TableCell colSpan={7}>No hay tokens.</TableCell>
              </TableRow>
            )}
            {tokens.map((token) => (
              <TableRow key={token.pat_id}>
                <TableCell>{token.label}</TableCell>
                <TableCell>
                  <code>{token.client_id}</code>
                </TableCell>
                <TableCell>
                  {(token.scopes || []).map((s) => (
                    <Chip key={s} label={s} size="small" sx={{ mr: 0.5 }} />
                  ))}
                </TableCell>
                <TableCell>{token.status || "—"}</TableCell>
                <TableCell>{formatRelative(token.last_used_at)}</TableCell>
                <TableCell>{formatRelative(token.created_at)}</TableCell>
                <TableCell align="right">
                  {token.status === "active" && (
                    <IconButton
                      size="small"
                      title="Rotar"
                      onClick={() => setRotateTarget(token)}
                    >
                      <AutorenewIcon fontSize="small" />
                    </IconButton>
                  )}
                  {token.status === "active" && (
                    <IconButton
                      size="small"
                      color="error"
                      title="Revocar"
                      onClick={() => onRevoke(token.pat_id)}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <AccessTokenCreateModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onCreate={onCreate}
      />

      <AccessTokenRotateModal
        open={Boolean(rotateTarget)}
        token={rotateTarget}
        onClose={() => setRotateTarget(null)}
        onRotate={onRotate}
      />
    </Box>
  );
}
